import React from 'react'
import SuperClinicLoginView from './SuperClinicLoginView'

const Login = () => {
  return <SuperClinicLoginView />
}

export default Login
